export default __webpack_public_path__ + "static/media/Patronage of the Four Fiends.f59fbfb3.jpg";